export const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  boxStep: {
    cursor: "pointer",
  },
  boxStepSuccessful: {
    cursor: "default",
  },
  customValid: {
    minHeight: "1rem",
    marginTop: "0px",
    padding: "0 12px",
  },
  customInValid: {
    minHeight: "1rem",
    fontSize: "0.8rem",
    marginTop: "0px",
    padding: "0 12px",
  },
  // right: {
  //     position: 'absolute',
  //     right: 24,
  //     display: 'flex',
  //     justifyContent: 'center',
  //     alignItems: 'center'
  // },
  menuItem: {
    fontSize: "0.8rem",
  },
  step: {
    textAlign: "center",
    marginBottom: theme.spacing(1),
    color: "#e4e5e8",
    fontSize: "1.4rem",
  },
  stepActive: {
    color: "#ff6b5c !important",
  },
  textGray: {
    color: "#9497a3",
  },
  message: {
    marginBottom: 0,
    marginTop: 0,
  },
  phone: {
    color: "#292f48",
    fontWeight: 500,
  },
  countdown: {
    color: "#292f48",
    fontWeight: 500,
  },
  infoCode: {
    color: "#292f48",
  },
  titleProcess: {
    color: "#ff6b5c",
    fontSize: "1.3rem",
    marginBottom: theme.spacing(2),
    fontWeight: 500,
  },
  activeLine: {
    backgroundColor: "#ff6b5c !important",
  },
  line: {
    height: "2px",
    width: "100%",
    backgroundColor: "#e4e5e8",
  },
  process: {
    marginBottom: theme.spacing(8),
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  button: {
    cursor: "pointer",
    // paddingBottom: theme.spacing(2),
    // paddingTop: theme.spacing(2),
  },
  logo: {
    cursor: "pointer",
    width: "40%",
    maxWidth: 150,
    marginBottom: theme.spacing(6),
  },
  btnBottom: {
    marginTop: theme.spacing(3),
  },
  contentExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#909090",
  },
  numberExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#292f48",
  },
});
